import {MutationOptions, useMutation} from 'react-query';
import { APIError, APIResponse, API_URL, post } from '../api';

function useFundWallet<T>(
  options?: MutationOptions<APIResponse<T>, APIError, Record<any, any>>,
) {
  const {
    isLoading: fundingWallet,
    isError: isFundingWalletError,
    error: fundingWalletError,
    mutate: fundWallet,
  } = useMutation(async (variables: Record<any, any>) => {
    return await post(API_URL + '/account/wallet/fund-wallet', variables, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ localStorage.getItem('token')}`,
      },
    });
  }, options);

  return {
    fundWallet,
    isFundingWalletError,
    fundingWalletError,
    fundingWallet,
  };
}

export default useFundWallet;